/**
 * @file Parent pay camp entry text.
 */

import React from 'react';
import PropTypes from 'prop-types';

import {
  getAccountCheckoutGreetingName,
  getAccountUsername,
} from '../../../util/account';
import { getAsset } from '../../../util/assets';
import Button from '../../global/Button';
import OnboardingLayoutContentNarrow from '../../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutContentNarrow';
import ContextualString from '../../contextual/ContextualString';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    has_charity: PropTypes.bool,
    charity_description: PropTypes.string,
    is_demo: PropTypes.bool,
    has_free_trial: PropTypes.bool,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func,
};

const DiscoverAlbumFolderStartCampParentPay = ({
  albumFolder,
  onGetStarted,
}) => {
  const displayName = getAccountCheckoutGreetingName(albumFolder.account);
  const username = getAccountUsername(albumFolder.account);
  const displayNameComponent = (() => {
    if (username) {
      return (
        <a href={`/@${username}`} className="text-sm mb-2">
          By {displayName}
        </a>
      );
    }
    return <p className="text-sm">By {displayName}</p>;
  })();

  return (
    <OnboardingLayoutContentNarrow>
      <h4 className="mb-1 text-center">Welcome to</h4>
      <h2 className="text-black mb-1 text-center">{albumFolder.name}!</h2>

      {displayName && displayNameComponent}

      <p className="mb-0 text-center">
        <ContextualString
          id="albumDiscoveryEntryHeadline"
          type={albumFolder?.album_type}
          subtype={albumFolder?.album_subtype}
          values={{
            displayName,
          }}
        />
        <br />
        <br />
        <ContextualString
          id="albumDiscoveryEntry"
          type={albumFolder?.album_type}
          subtype={albumFolder?.album_subtype}
        />
      </p>
      <img
        src={getAsset('/waldo-way.png')}
        height="140px"
        className="my-2"
        alt="Waldo Way"
      />
      <Button onClick={onGetStarted} className="mt-2" btnBlock>
        Let&apos;s Get Started!
      </Button>

      <div className="d-flex mt-1">
        <a href="/terms" target="_blank" className="m-auto text-xs">
          Terms of Use
        </a>
      </div>
    </OnboardingLayoutContentNarrow>
  );
};

DiscoverAlbumFolderStartCampParentPay.propTypes = propTypes;

export default DiscoverAlbumFolderStartCampParentPay;
